import * as Types from '@/types';

import { gql } from '@apollo/client';
export const PricingWeeklyPurchaseQuantityFieldsFragmentDoc = gql`
  fragment PricingWeeklyPurchaseQuantityFields on WeeklyPurchaseQuantity {
    end_date
    quantity
    start_date
  }
`;
